import { render, staticRenderFns } from "./LightSourceDescription.vue?vue&type=template&id=6f5e4afd&scoped=true"
import script from "./LightSourceDescription.vue?vue&type=script&lang=ts"
export * from "./LightSourceDescription.vue?vue&type=script&lang=ts"
import style0 from "./LightSourceDescription.vue?vue&type=style&index=0&id=6f5e4afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e4afd",
  null
  
)

export default component.exports